<script setup lang="ts">
    // @ts-expect-error raison: lib externe mal typée
    import { ref, defineExpose, defineProps, reactive, onMounted } from 'vue';
    import { generateUUID } from '@/utils';

    const props = defineProps({
        attributs: { type: Array as () => any[], required: true },
    });
    const isModalOpen = ref(false);
    let promise: Promise<any>;
    let resolvePromise: any;
    let rejectPromise: any;
    const formData = reactive({
        //attributs_valeurs: {} as any
        attributs: [] as any[],
    });
    const produit = reactive({
        id: null,
        nom: '',
    });

    onMounted(() => {
        /*props.attributs.forEach((attribut) => {
            formData.attributs_valeurs[attribut.nom] = null;
        });*/
    });

    async function open(_produit: any) {
        Object.assign(produit, _produit);
        promise = new Promise((resolve, reject) => {
            resolvePromise = resolve;
            rejectPromise = reject;
        });
        isModalOpen.value = true;
        return await promise;
    }

    function onClose() {
        resolvePromise(false);
    }

    function onConfirm() {
        const noms: any[] = [];
        const valeurs: any = {};
        Object.keys(formData.attributs).forEach((key: any) => {
            noms.push(formData.attributs[key].nom);
            valeurs[formData.attributs[key].nom] = formData.attributs[key].valeur;
        });
        resolvePromise(JSON.parse(JSON.stringify({
            guid: generateUUID(),
            nom: noms.join('|'),
            valeurs: valeurs,
            produit_attributs: formData.attributs
        })));
        isModalOpen.value = false;
    }

    function onReject() {
        resolvePromise(false);
        isModalOpen.value = false;
    }

    function onAttributValeurSelected(event: Event, attribut: any) {
        const target = event.target as HTMLSelectElement;
        const index = formData.attributs.findLastIndex((a: any) => a.nom === attribut.nom);
        if (index === -1) {
            formData.attributs.push({
                guid: generateUUID(),
                produit_id: produit.id,
                attribut_id: attribut.id,
                nom: attribut.nom,
                valeur: target.value,
            });
        } else {
            formData.attributs[index].valeur = target.value;
        }
    }

    defineExpose({ open });
</script>

<template>
    <custom-modal v-model:show="isModalOpen" @closed="onClose">
        <template #header>
            <h4 class="font-semibold">Formulaire Variant</h4>
        </template>
        <div>
            <div class="form-field-floating full my-5" v-for="(attribut, index) of attributs" :key="'attribut_' + index">
                <select class="form-input-select" @change="onAttributValeurSelected($event, attribut)">
                    <option :value="null">Aucun attribut sélectionné</option>
                    <option v-for="valeur of attribut.valeurs" :key="valeur" :value="valeur">{{ valeur }}</option>
                </select>
                <label for="paiement_echeance_duration">{{ attribut.nom }}</label>
            </div>
        </div>
        <template #footer>
            <button id="btn-confirmation-confirm" class="btn-ultra white2" style="justify-content: center;" @click="onConfirm">Valider</button>
            <button id="btn-confirmation-reject" class="btn-ultra white2" style="justify-content: center;" @click="onReject">Annuler</button>
        </template>
    </custom-modal>
</template>
